// extracted by mini-css-extract-plugin
export var topContainer = "category-module--topContainer--18ddd";